export const WithdrawalRoute = 'account/withdrawal'
